import {
  DOCUMENTPATH,
  DOCUMENTADDED,
  DOCUMENTDIALOGSTATUS,
  DOCUMENTLOADING,
} from "@/store/actions/documents";

const state = {
  from: null,
  redirected: null,
  document: null,
  active: null,
  loading: null,
};

const getters = {
  getDocumentState: (state) => state,
  getDocumentPath: (state) => state.from,
  getAddedDocument: (state) => state.document,
  getDocumentDialogStatus: (state) => state.active,
  getDocumentLoadingStatus: (state) => state.loading,
};

const actions = {};

const mutations = {
  [DOCUMENTPATH]: (state, value) => {
    state.from = value;
  },
  [DOCUMENTADDED]: (state, value) => {
    state.document = value;
  },
  [DOCUMENTDIALOGSTATUS]: (state, value) => {
    state.active = value;
  },
  [DOCUMENTLOADING]: (state, value) => {
    state.loading = value;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
